module.exports = __webpack_public_path__ + "img/0-78.6c9b596a.jpg";